import { tokenType } from "../../containers/authv2/TokenType";
import { ActionType } from "../action-types";


export interface UserSettings {
  theme: string
  roles_l: string[]
  last_name: string
  language: string
  first_name: string
  devices_info: DevicesInfo[]
  apps: string[]
}

export interface DevicesInfo {
  uuid: string
  push_id: string
  platform: string
}

export interface TenantInfo {
  type: string
  theme: Theme
  text: Text
  sname: string
  signup: Signup
  logos: Logos
  dial_out: boolean
  dial_in: boolean
  clients: Clients
  brandname: string
  brandUrl: string
  backgroundImages: BackgroundImages
}

export interface Theme {
  lite: Lite
  dark: Dark
}

export interface Lite {
  main: string
  primary: string
  primary100: string
  primary300: string
  primary500: string
  linkText: string
  danger: string
  whileOnline: string
  bgSecondary: string
  callNotification: string
}

export interface Dark {
  main: string
  primary: string
  primary100: string
  primary300: string
  primary500: string
  linkText: string
  danger: string
  whileOnline: string
  bgSecondary: string
  callNotification: string
}

export interface Text {
  portal_register_heading: string
  portal_regiser_body: string
  portal_login_heading: string
  portal_login_body: string
}

export interface Signup {
  social: boolean
  normal: boolean
}

export interface Logos {
  logoWhite: string
  logoDark: string
  favicon: string
}

export interface Clients {
  mobile_apps: MobileApps
  mobile: boolean
  desk_apps: DeskApps
  desk: boolean
}

export interface MobileApps {
  ios: any
  android: any
}

export interface DeskApps {
  windows: any
  mac: any
  linux: any
}

export interface BackgroundImages {
  portal: any
  landingPage: any
}

export const setUserRoles = (payload: any) => {
  return {
    type: ActionType.SET_USER_ROLE,
    payload: payload,
  };
};
export const setUser = (user: any) => {
  return {
    type: ActionType.SET_USER,
    payload: user,
  };
};
export const SetAccountActiveStep = (number: number) => {
  return {
    type: ActionType.SET_ACCOUNT_ACTIVE_STATE,
    payload: number,
  };
};
export const SetAuthState = (boolean: number) => {
  return {
    type: ActionType.SET_AUTH_STATE,
    payload: boolean,
  };
};
export const SetAppsList = (data: string[]) => {
  return {
    type: ActionType.SET_APPSLIST,
    payload: data,
  };
};
export const SetUserSettings = (data: UserSettings) => {
  return {
    type: ActionType.SET_USERSETTINGS,
    payload: data,
  };
};

export const SetAccessToken = (data: tokenType) => {
  return {
    type: ActionType.SET_TOKEN,
    payload: data,
  };
};
export const SetEncodedToken = (data: string) => {
  return {
    type: ActionType.SET_ENCODED_TOKEN,
    payload: data,
  };
};
export const SetAccountInfo = (data: TenantInfo | undefined) => {
  return {
    type: ActionType.SET_ACCOUNTINFO,
    payload: data,
  };
};

